import React from 'react'

function Idle(props) {
  const fillColor = props.hovered === 'idle' || props.selected === 'Idle Event' ? '#F37320' : '#545455'
  const strokeColor = props.hovered === 'idle' || props.selected === 'Idle Event' ? '#F37320' : '#707070'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="47.601" height="103.267" viewBox="0 0 47.601 103.267">
      <g id="Group_7420" data-name="Group 7420" transform="translate(18253.813 -10721.746)">
        <g id="Rectangle_5577" data-name="Rectangle 5577" transform="translate(-18253.813 10727.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5578" data-name="Rectangle 5578" transform="translate(-18250.352 10777.412)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="44.139" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="43.139" rx="3.5" fill="none" />
        </g>
        <path id="Path_3645" data-name="Path 3645" d="M3614.863,5076.646h19.228" transform="translate(-21854.277 5645.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
      </g>
    </svg>
  )
}

export default Idle